import type { NextPage } from 'next'
import Head from 'next/head'
import { Layout, Main } from 'layout'
import { Container } from 'atoms'
import ContactForm from 'organisms/ContactForm'

const KontaktPage: NextPage = () => (
  <Layout>
    <Head>
      <title>Kontakt zu mir | FrauenCoach</title>
      <meta name="description" content="Kontakt zu mir | FrauenCoach" />
    </Head>
    <Main>
      <Container className="text-center">
        <h1>Kontakt</h1>
        <ContactForm scrollUpOnSuccess />
      </Container>
    </Main>
  </Layout>
)

export default KontaktPage
